module.exports = __webpack_public_path__ + "img/United States Virgin Islands.af9538cd.svg";